import {
  AppBar,
  Toolbar,
  Box,
  Typography,
  Avatar,
  useMediaQuery,
  styled,
} from "@mui/material";
import { useLocation } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import Header from "./header";
import ProfileImg from "../assets/user.png";
import {palette, theme as colorTheme}  from "../Convoze.theme"
import { PAGE_PADDING } from "./ParentWrapper";

export const TOPBAR_HEIGHT = 56;



/* ----------  route location pathname for title and subtitle ---------- */

const pageMeta = [
  {
    pattern: /^\/user\/audio-analytics\//,
    meta: {
      title: "Audio Analytics",
      subtitle: "Analyze your Audio Analytics here",
    },
  },

  /* exact paths */
  {
    pattern: /^\/user\/dashboard$/,
    meta: {
      title: "Dashboard",
      subtitle: "Overview of all the interactions and insights",
    },
  },
  {
    pattern: /^\/user\/dashboard2$/,
    meta: {
      title: "Dashboard",
      subtitle: "Overview of all the interactions and insights",
    },
  },
  {
    pattern: /^\/user\/audio-details$/,
    meta: {
      title: "Interactions",
      subtitle:
        "Conversations and call recordings uploaded on convoze platform",
    },
  },
  {
    pattern: /^\/user\/leaderboard$/,
    meta: {
      title: "LeaderBoard",
      subtitle: "Have comparative analysis of all your agents",
    },
  },
  {
    pattern: /^\/user\/agent\/list$/,
    meta: {
      title: "Agents Overview",
      subtitle: "Manage and monitor your team of agents",
    },
  },
  {
    pattern: /^\/user\/user-management$/,
    meta: {
      title: "User Management",
      subtitle: "Manage call-center agents, managers, and administrators",
    },
  },
  {
    pattern: /^\/user\/training$/,
    meta: {
      title: "Training Activation",
      subtitle: "Upload your QA SOP and activate 72-hour AI training",
    },
  },
  {
    pattern: /^\/user\/billing$/,
    meta: {
      title: "Billing Dashboard",
      subtitle: "Monitor your AI Speech Analytics usage and billing",
    },
  },
  {
    pattern: /^\/user\/setting$/,
    meta: {
      title: "My Profile",
      subtitle: "Personal details and account settings",
    },
  },
  {
    pattern: /^\/user\/settings$/,
    meta: { title: "Security Settings", subtitle: "Manage your account here" },
  },
  {
    pattern: /^\/user\/account\/manage$/,
    meta: {
      title: "Account Management",
      subtitle: "Manage your complete account here",
    },
  },
  {
    pattern: /^\/user\/audio$/,
    meta: {
      title: "Upload Audio",
      subtitle: "Upload audio for instant conversation review",
    },
  },
  {
    pattern: /^\/agent\/dashboard$/,
    meta: { title: "Agent Dashboard", subtitle: "View performance of Agents" },
  },
    {
    pattern: /^\/user\/agent-profile\//,
    meta: {
      title: "Agent Profile",
      subtitle: "Analyze your Agent Profile",
    },
  },
  {
    pattern: /^\/agent\/my-calls$/,
    meta: { title: "Call Analytics", subtitle: "View analysis of your calls" },
  },
  {
    pattern: /^\/agent\/my-kpis$/,
    meta: { title: "My KPIs", subtitle: "Analyze your KPIs here" },
  },
  {
    pattern: /^\/agent\/leaderboard$/,
    meta: { title: "Agent Leaderboard", subtitle: "View performance of Agents" },
  },
  {
    pattern: /^\/agent\/settings$/,
    meta: { title: "Agent Settings", subtitle: "Agent settings" },
  },
   {
    pattern: /^\/super-admin\/process-management$/,
    meta: { title: "Process Management", subtitle: "" },
  },
  {
    pattern: /^\/super-admin\/client-management$/,
    meta: { title: "Client Management", subtitle: "" },
  },

  /* Remaining routed pages — titles match their side-nav labels so every page has a header. */
  { pattern: /^\/user\/dashboard-new$/, meta: { title: "Dashboard", subtitle: "Overview of all the interactions and insights" } },
  { pattern: /^\/user\/audio-intelligence$/, meta: { title: "Audio Analytics", subtitle: "Analyze your Audio Analytics here" } },
  { pattern: /^\/user\/account$/, meta: { title: "Account", subtitle: "" } },
  { pattern: /^\/user\/manual-audit(-new)?$/, meta: { title: "Manual Audit", subtitle: "" } },
  { pattern: /^\/user\/manual-dashboard$/, meta: { title: "Manual Dashboard", subtitle: "" } },
  { pattern: /^\/user\/manual-audit-fields$/, meta: { title: "Manual Audit Fields", subtitle: "" } },
  { pattern: /^\/user\/manual-audit-options$/, meta: { title: "Manual Audit Options", subtitle: "" } },
  { pattern: /^\/user\/knowledge-portal$/, meta: { title: "Knowledge Portal", subtitle: "" } },
  { pattern: /^\/user\/sensitive-keyword-alerts$/, meta: { title: "Sensitive Keyword Alert", subtitle: "" } },
  { pattern: /^\/user\/feedback-acceptance$/, meta: { title: "Feedback Acceptance Status", subtitle: "" } },
  { pattern: /^\/user\/good-call-library$/, meta: { title: "Good Call Library", subtitle: "" } },
  { pattern: /^\/user\/curator\/call-analysis-import$/, meta: { title: "Call Analysis Import", subtitle: "" } },
  { pattern: /^\/user\/qa-edit\//, meta: { title: "QA Edit", subtitle: "" } },
  { pattern: /^\/user\/agent-assignment$/, meta: { title: "Agent Assignment", subtitle: "" } },
  { pattern: /^\/(user|super-admin)\/roles-permissions$/, meta: { title: "Roles & Permissions", subtitle: "" } },
  { pattern: /^\/demo\/audio\/upload-file$/, meta: { title: "Upload Audio", subtitle: "Upload audio for instant conversation review" } },
  { pattern: /^\/demo\/audio\/file-details$/, meta: { title: "Audio Files", subtitle: "" } },
  { pattern: /^\/demo\/audio\/transcript\//, meta: { title: "Transcript", subtitle: "" } },
  { pattern: /^\/super-admin\/dashboard$/, meta: { title: "Dashboard", subtitle: "" } },
  { pattern: /^\/super-admin\/arrange-qa-parameter(-legacy)?$/, meta: { title: "Arrange QA Parameter", subtitle: "" } },
  { pattern: /^\/super-admin\/qa-parameter-json(-legacy)?$/, meta: { title: "QA Parameters (JSON)", subtitle: "" } },
  { pattern: /^\/super-admin\/agent-create$/, meta: { title: "Create Agent", subtitle: "" } },
  { pattern: /^\/super-admin\/qa-parameter-prompt\//, meta: { title: "QA Parameter Prompt", subtitle: "" } },
  { pattern: /^\/super-admin\/entities-prompt\//, meta: { title: "Entities Prompt", subtitle: "" } },
  { pattern: /^\/super-admin\/rediarization-prompt\//, meta: { title: "Rediarization Prompt", subtitle: "" } },
  { pattern: /^\/super-admin\/overview-prompt\//, meta: { title: "Overview Prompt", subtitle: "" } },
  { pattern: /^\/super-admin\/customer-insight-prompt\//, meta: { title: "Customer Insight Prompt", subtitle: "" } },
  { pattern: /^\/super-admin\/agent-insight-prompt\//, meta: { title: "Agent Insight Prompt", subtitle: "" } },
  { pattern: /^\/super-admin\/conversion-insight-prompt\//, meta: { title: "Conversion Insight Prompt", subtitle: "" } },
  { pattern: /^\/super-admin\/user-management$/, meta: { title: "User Management", subtitle: "" } },
  { pattern: /^\/super-admin\/company-access$/, meta: { title: "Company Access", subtitle: "" } },
  { pattern: /^\/super-admin\/billing$/, meta: { title: "Billing Analytics", subtitle: "" } },
  { pattern: /^\/super-admin\/billing\/invoice$/, meta: { title: "Invoice", subtitle: "" } },
  { pattern: /^\/super-admin\/cron-management$/, meta: { title: "Cron Management", subtitle: "" } },
  { pattern: /^\/super-admin\/keyword-alerts$/, meta: { title: "Keyword Alerts", subtitle: "" } },
  { pattern: /^\/super-admin\/agent-call-emails$/, meta: { title: "Agent Call Emails", subtitle: "" } },
  { pattern: /^\/super-admin\/stt-credential-management$/, meta: { title: "STT Credentials", subtitle: "" } },
  { pattern: /^\/super-admin\/llm-credential-management$/, meta: { title: "LLM Credentials", subtitle: "" } },
  { pattern: /^\/super-admin\/update-tracker$/, meta: { title: "Update Tracker", subtitle: "" } },
  { pattern: /^\/super-admin\/ai-engine-mode-management$/, meta: { title: "AI Engine Modes", subtitle: "" } },
  { pattern: /^\/super-admin\/activity-logs$/, meta: { title: "Activity Log", subtitle: "" } },
  { pattern: /^\/super-admin\/settings$/, meta: { title: "Settings", subtitle: "Manage your account here" } },
  { pattern: /^\/agent\/chatbot$/, meta: { title: "Chatbot", subtitle: "" } },
  { pattern: /^\/agent\/daily-tasks$/, meta: { title: "Daily Tasks", subtitle: "" } },
];

const defaultMeta = { title: "", subtitle: "" };

const getMeta = (path) => {
  const hit = pageMeta.find((p) => p.pattern.test(path));
  return hit ? hit.meta : defaultMeta;
};

const primary = colorTheme('palette', 'primary').value;


export default function Topbar() {
  const { pathname } = useLocation();
  const token = localStorage.getItem("token");
  const decodedToken = token ? jwtDecode(token) : {};
  const isMobile = useMediaQuery("(max-width:600px)");

  const meta = getMeta(pathname);

  return (
    <AppBar
      position="sticky"
      elevation={0}
      sx={(t) => ({
        backgroundColor: "rgba(255,255,255,0.72)",
        backdropFilter: "blur(12px)",
        borderBottom: "1px solid rgba(0,0,0,0.06)",
        boxSizing: "border-box",
        zIndex: 999,
      })}
    >
      <Toolbar
        variant="dense"
        disableGutters
        sx={{
          // Fixed height (not just a minimum) so the header is identical on every page.
          height: TOPBAR_HEIGHT,
          minHeight: TOPBAR_HEIGHT,
          // Same horizontal inset as the page content; on mobile, leave room for the
          // side-nav's fixed menu button.
          pl: { xs: 7, md: PAGE_PADDING.md },
          pr: PAGE_PADDING,
          gap: 2,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Header title={meta.title} subtitle={meta.subtitle} inToolbar />

        <Box sx={{ display: "flex", alignItems: "center", gap: 1, flexShrink: 0, ml: "auto" }}>
          {
            <Box sx={{ lineHeight: 1, textAlign: "right" }}>
              <Typography
                sx={{
                  fontSize: {
                    xs: "0.625rem",
                    sm: "0.6875rem",
                    md: "0.75rem",
                    lg: "0.75rem",
                    xl: '0.77rem'
                  },
                  fontWeight: 500,
                  color: "rgba(0,0,0,.78)",
                }}
              >
                {decodedToken?.userName || ""}
              </Typography>
              <Typography
                sx={{
                  fontSize: {
                    xs: '0.5625rem',  
                    sm: '0.625rem',  
                    md: '0.6875rem',  
                    lg: '0.6875rem',   
                    xl:'0.77rem'
                  },
                  fontWeight: 600,
                  color: primary
                }}
              >
                {decodedToken?.userRole || ""}
              </Typography>
            </Box>
          }
          <Avatar
            src={ProfileImg}
            sx={{
              width: 26,
              height: 26,
              boxShadow: "0 0 0 1px rgba(0,0,0,.06)",
            }}
          />
        </Box>
      </Toolbar>
    </AppBar>
  );
}
